import type { PostMeta } from "../posts";

export const meta: PostMeta = {
  slug: "cat-vs-civil-services-vs-masters",
  title: "CAT vs Civil Services vs Master's: Evaluating Post-DU Career Decisions",
  description:
    "How to evaluate MBA (CAT), UPSC Civil Services, and Master's in Economics after graduating from DU. Time horizons, preparation risk, salary profiles, and decision framework.",
  pubDate: "2026-07-01",
  updatedDate: "2026-07-28",
  authorSlug: "uday-kumar",
  category: "careers",
  tags: ["careers", "CAT", "UPSC", "masters", "decision-framework", "upsc-cse"],
  readMinutes: 12,
  heroEyebrow: "Careers · Decision Framework Masterclass",
};

export function Body() {
  return (
    <>
      <p>
        Choosing between corporate management (MBA via CAT), public administration (UPSC Civil Services), or specialized academia (Master's in Economics) is the central career decision facing Indian undergraduates.
      </p>

      <figure className="my-8">
        <img
          src="/blog/inline-ui-3.jpg"
          alt="Comparative visual framework comparing preparation risk versus salary outcome across MBA, UPSC, and Master's degrees."
          width={1200}
          height={675}
          className="w-full h-auto border border-rule bg-card"
        />
        <figcaption className="mt-3 mono-label text-pencil text-center">
          Figure 1: Risk vs. Horizon Trajectory Matrix. Evaluate career options across preparation window, financial upside, and lock-in risk before third year.
        </figcaption>
      </figure>

      <h2>Decision Matrix: Risk, Preparation Window, &amp; Outcomes</h2>
      <div className="overflow-x-auto my-6">
        <table className="w-full text-left text-sm border-collapse border border-rule">
          <thead>
            <tr className="bg-card font-semibold border-b border-rule">
              <th className="p-3 border-r border-rule">Pathway</th>
              <th className="p-3 border-r border-rule">Primary Entrance</th>
              <th className="p-3 border-r border-rule">Prep Window</th>
              <th className="p-3">Risk-Reward Profile</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-rule">
            <tr>
              <td className="p-3 border-r border-rule font-medium">MBA (IIMs / XLRI)</td>
              <td className="p-3 border-r border-rule">
                <a href="https://iimcat.ac.in/" target="_blank" rel="noopener noreferrer">IIM CAT</a>
              </td>
              <td className="p-3 border-r border-rule">6 to 12 Months</td>
              <td className="p-3">Moderate risk. Fast corporate entry into management consulting &amp; finance.</td>
            </tr>
            <tr>
              <td className="p-3 border-r border-rule font-medium">Civil Services (IAS / IFS)</td>
              <td className="p-3 border-r border-rule">
                <a href="https://upsc.gov.in/" target="_blank" rel="noopener noreferrer">UPSC CSE</a>
              </td>
              <td className="p-3 border-r border-rule">18 to 36 Months</td>
              <td className="p-3">High risk / High impact. Public administration, policy authority, long prep tail.</td>
            </tr>
            <tr>
              <td className="p-3 border-r border-rule font-medium">MA Economics (DSE / JNU)</td>
              <td className="p-3 border-r border-rule">
                <a href="https://pgcuet.samarth.ac.in/" target="_blank" rel="noopener noreferrer">CUET PG</a>
              </td>
              <td className="p-3 border-r border-rule">8 to 12 Months</td>
              <td className="p-3">Low risk / High skill. Quantitative analytics, research, central banking (RBI).</td>
            </tr>
          </tbody>
        </table>
      </div>

      <h2>Related Career Reading</h2>
      <p>
        Explore specific career breakdowns in our guides on{" "}
        <a href="/blog/is-ma-economics-worth-it" className="font-semibold underline text-grade">
          Is an MA in Economics Worth It?
        </a>{" "}
        and{" "}
        <a href="/blog/what-economics-honours-grads-do" className="font-semibold underline text-grade">
          What Economics Honours Graduates Do
        </a>
        .
      </p>
    </>
  );
}


